export const ACTION_MENU_USER = {
  INFO: 'INFO',
  LOGOUT: 'LOGOUT',
  SHIFTHANDOVER: 'SHIFTHANDOVER',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  SCAN_CUSTOMER_INFO: 'SCAN_CUSTOMER_INFO',
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE'
};
